const canAccessAffiliateProgram = require("../../lib/affiliateProgram/canAccessAffiliateProgram")
  .default;

const menuItems = {
  personal: {
    name: "personal",
    label: "Personal",
    icon: "fal fa-user",
    nativeIcon: "user",
    permissions: [],
    group: "account"
  },
  payments: {
    name: "payments",
    label: "Payments",
    icon: "fal fa-coins",
    nativeIcon: "coins",
    permissions: [],
    group: "account"
  },
  partnership: {
    name: "partnership",
    label: "Partners",
    icon: "fal fa-gift-card",
    nativeIcon: "gift-card",
    requiresPremium: true,
    permissions: ["plans.other_discounts"],
    group: "account"
  },
  affiliate: {
    name: "affiliate",
    label: "Affiliate program",
    icon: "fal fa-link",
    nativeIcon: "link",
    requiresPremium: false,
    permissions: [],
    group: "account",
    canShow: async ({ apiClient }) => {
      let data;

      try {
        data = await apiClient.get({
          urlPath: "app.affiliateProgram.details"
        });
      } catch (error) {
        data = null;
      }

      return canAccessAffiliateProgram(data);
    }
  },
  notifications: {
    name: "notifications",
    label: "Notifications",
    icon: "fal fa-bell",
    nativeIcon: "bell",
    permissions: [],
    group: "settings"
  },
  markets: {
    name: "markets",
    label: "Markets",
    icon: "fal fa-analytics",
    nativeIcon: "analytics",
    permissions: [],
    group: "settings"
  },
  tags: {
    name: "tags",
    label: "Tags settings panel",
    icon: "fal fa-tag",
    nativeIcon: "tag",
    requiresPremium: true,
    permissions: ["plans.stock_tags"],
    group: "settings"
  },
  otherAssets: {
    name: "other-assets",
    label: "Other assets settings panel",
    icon: "fal fa-car",
    nativeIcon: "car",
    requiresPremium: false,
    permissions: [],
    group: "settings"
  }
};

module.exports = {
  useInternalWebBrowserForHosts: [],
  recommendationsToFetch: 5,
  intercomAppID: "hf7bcrz9",
  trackEvents: false,
  googleAnalyticsId: "UA-46882716-1",
  oldAccessLevelStorageKey: "OLD_ACCESS_LEVEL",
  paymentDetailsStorageKey: "PAYMENT_DETAILS",
  introductionModalStorageKey: "SHOW_INTRODUCTION_MODAL",
  shouldRedirectToNativeAfterPaymentStorageKey:
    "SHOULD_REDIRECT_TO_NATIVE_AFTER_PAYMENT",
  marketingParams: {
    storageKey: "marketingParams",
    allowedPrefixes: ["utm_"],
    allowedNames: [
      "gclid",
      "fbclid",
      "ttclid",
      "gad_source",
      "gad_campaignid",
      "gbraid"
    ],
    requestHeaderName: "X-App-Params"
  },
  recaptchaKey: "6LcIhuwSAAAAAC3RSaqpiD4j8NHaPKRG7OQdT704",
  squaberCommentDescriptionMaxLength: 300,
  userIdCookieName: "squaber_auth_user_id",
  authTokenCookieName: "squaber_auth_token",
  buildNumber: 6,
  socketIoKeys: {
    notifications: "browser_notification",
    portfolios: "portfolio_exchange"
  },
  webSocketPort: "",
  nativeAppScheme: "investio.squaber.staging://",
  amplitude: {
    apiKey: "5104277dcf4c7d4822fcb983ac4406eb",
    enabled: false
  },
  numberOfDaysUntilAffiliateCookieExpiry: 60,
  pathnamesWithoutOverlies: [
    "/payment-details/",
    "/offer-checkout/",
    "/skorzystaj-z-oferty/",
    "/l/",
    "/plans"
  ],
  maxDaysWithoutQuotations: 7,
  revenueCatApiKey: {
    ios: "appl_TNMkdnEzbjSVzlkGjrFEUNwYiCp",
    android: "goog_RoLCLxxUyDhMPsnRuwzvGrgxZgu"
  },
  staticFilesHostName: "squaber-statics-stage.s3.amazonaws.com",
  firebase: {
    apiKey:
      "AAAAM9wTFK0:APA91bETjQMG58ETrGdkb3ODFGIPgdlTzr9FhVg_o3O2U1mrJpCV1uzZYSzACD2_Q_vWU2tO-YjrgL7f4gJEot0uXwe_wk3e0wdnU2tQk9j2p7ooBM6b22JP843zvyfB7Rge2FiKPiXS",
    authDomain: "investio-backup.firebaseapp.com",
    databaseURL: "https://squaber-staging-aws.firebaseio.com/",
    storageBucket: "investio-backup.appspot.com",
    appId: {
      ios: "1:222735570093:ios:3cfcab4505acd03c4f6224",
      android: "1:222735570093:android:eab657a003707bc4"
    },
    projectId: "investio-backup",
    messagingSenderId: "222735570093",
    measurementId: "G-189639239",
    nativeSdkApiKey: {
      ios: "AIzaSyALMtHWVomF7INsrfPpIwArtiujrdQUeoM",
      android: "AIzaSyDDR8KXvnkCEAP-4CVMiSnB85QazmPTuaE"
    }
  },
  availableCurrencies: ["PLN", "USD"],
  settingsGroups: [
    {
      name: "account",
      label: "Account"
    },
    {
      name: "settings",
      label: "Settings"
    }
  ],
  nativeMenu: {
    userCategories: [
      menuItems.personal,
      menuItems.payments,
      menuItems.partnership,
      menuItems.affiliate
    ],
    settingsCategories: [
      menuItems.notifications,
      menuItems.markets,
      menuItems.tags,
      menuItems.otherAssets
    ]
  },
  settingsCategories: [
    menuItems.personal,
    menuItems.payments,
    menuItems.partnership,
    menuItems.affiliate,
    menuItems.notifications,
    menuItems.markets,
    menuItems.tags,
    menuItems.otherAssets
  ],
  trackSMEvents: true,
  googleAuthWebClientId:
    "222735570093-h87resini5b5ep55jgm54bsr060gkmf7.apps.googleusercontent.com",
  intercom: {
    appId: "cw67skqk",
    apiKey: {
      ios: "ios_sdk-a5a9f4656ea4a55c55b1ef5eb35a9d8cf07357d9",
      android: "android_sdk-bd3ba271c55ea99b4b8d8dc0db3ab9ccf8deb86b"
    }
  },
  forceWebPaymentsInApp: false,
  invoicesEnabled: true,
  invoiceGenerationWindowDays: 123,
  blockPaymentLinksInApp: true,
  allowExternalLinks: {
    ios: true,
    android: false
  },
  newMenuItems: ["Insider"],
  printPaymentErrorText: false,
  alertCategories: [
    {
      name: "Company News",
      key: "media_monitor"
    },
    {
      name: "Price Alerts",
      key: "price_alerts"
    },
    {
      name: "Recommandations/splits",
      key: "stock_messages"
    },
    {
      name: "Demand Zones Strategy Alerts",
      key: "demand_zone"
    },
    {
      name: "Demand Zones Strategy Signals",
      key: "transaction_strategy_supply_demand"
    },
    {
      name: "Highs & Lows (H&L) Alerts",
      key: "highs_and_lows_correction"
    },
    {
      name: "Highs & Lows (H&L) Summary",
      key: "highs_and_lows_summary"
    },
    {
      name: "Highs & Lows (H&L) Signals",
      key: "transaction_strategy_highs_and_lows"
    },
    {
      name: "Trend Strategy",
      key: "transaction_strategy_trend"
    }
  ]
};
